import { merge } from '@fluentui/react';
import React, { useMemo } from 'react';
import { ResponsiveSize, useResponsiveSize } from '../contexts/responsiveContext';
import Category from './Category';

const CategorySmall = (props) => {

    const {
        active = false,
        badgeLabel = undefined,
        json = "",
        label = "Label",
        onClick = event => console.log(event)
    } = props;

    const { responsiveSize } = useResponsiveSize();

    const styles = useMemo(
        () => {
            let styles = {
                badge: {
                    root: {
                        height: 14,
                        width: 14
                    }
                },
                image: { height: 38 },
                outer: {
                    root: {
                        height: 71,
                        padding: "7px unset 3px",
                        width: 76,
                    }
                }
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        image: { height: 46 },
                        label: {
                            root: {
                                fontSize: 12,
                                lineHeight: "12px",
                            }
                        },
                        outer: {
                            root: {
                                height: 89,
                                padding: "13px unset 3px",
                                width: 96,
                            }
                        }
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    return <Category
        active={active}
        badgeLabel={badgeLabel}
        customStyles={styles}
        json={json}
        label={label}
        onClick={onClick}
    />;

};

export default CategorySmall;